/**
 * Where a Start Guide step gets its completed / locked state.
 *
 * "client" — derive it in the browser until the setup-guide API exists.
 * "server" — use the payload stored with setServerStartGuideStatus().
 *
 * Server payload for one project:
 * {
 *   steps: {
 *     business: { complete: true },
 *     registration: { complete: false, locked: true, lockReason: "..." }
 *   }
 * }
 */
export const START_GUIDE_STATUS_SOURCE = "client";

export const isServerStartGuideStatus = () =>
  START_GUIDE_STATUS_SOURCE === "server";
